import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EMPTY = { paid: new Set(), saved: new Set() };

export function useMyWorkshopStatus() {
  const { user } = useAuth();
  const [status, setStatus] = useState(EMPTY);
  const isCustomer = user?.role === "customer";
  const reload = useCallback(() => {
    if (!isCustomer) { setStatus(EMPTY); return; }
    api.get("/saved/status")
      .then((r) => setStatus({ paid: new Set(r.data.paid), saved: new Set(r.data.saved) }))
      .catch(() => {});
  }, [isCustomer]);
  useEffect(() => { reload(); }, [reload]);
  return { ...status, reload };
}
